import TodoApp from "./pages/TodoApp";
import Router from "./shared/Router";

function App() {
  return <Router />;
}

export default App;
